/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { ProjectConfigurationKeyEnum } from '../models/ProjectConfigurationKeyEnum';

export class GetProjectConfigurationKeyResponse {
  'key': ProjectConfigurationKeyEnum;
  /**
  * The value of the configuration key.
  */
  'value': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "key",
      "baseName": "key",
      "type": "ProjectConfigurationKeyEnum",
      "format": ""
    },
    {
      "name": "value",
      "baseName": "value",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return GetProjectConfigurationKeyResponse.attributeTypeMap;
  }

  public constructor() {
  }
}



